import { Modal, Flex, Typography } from 'antd';
import { useCertificateStore } from '../../certificate.store';
import { formatDate } from 'services/date';
import { CustomModal } from 'components/modal/CustomModal';

export const ModalObservation = () => {
  const {
    modals: { observation: observationModal },
    closeObservationModal
  } = useCertificateStore();

  const { title, date, autor, observation } = observationModal;

  return (
    <CustomModal
      title={title}
      open={date !== ''}
      width={700}
      onCancel={() => closeObservationModal()}
      destroyOnClose
      footer={null}
      zIndex={9999}
    >
      <Flex vertical gap={16}>
        <Flex vertical>
          <Typography.Text strong>Data</Typography.Text>
          <Typography.Text className="text-neutral-600">
            {formatDate(date, 'DD/MM/YYYY - HH:mm')}
          </Typography.Text>
        </Flex>
        <Flex vertical>
          <Typography.Text strong>Autor</Typography.Text>
          <Typography.Text className="text-neutral-600">
            {autor}
          </Typography.Text>
        </Flex>
        <Flex vertical>
          <Typography.Text strong>Motivo da emissão</Typography.Text>
          <Typography.Paragraph className="text-neutral-600">
            {observation}
          </Typography.Paragraph>
        </Flex>
      </Flex>
    </CustomModal>
  );
};
